export default () => `
  {
    currentOrder {
      promotionAdjustment {
        code
        amount
        currency
      }
    }
  }
`
